import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRemappingStore } from "../../../stores/remappingStore";
import RemappingDropdown from "./remappingDropdown";

interface RemappingFiltersProps {
  onSelectionChange: (selection: {
    series: string;
    generation: string;
    engine: string;
    ecu: string;
  }) => void;
}

const RemappingFilters: React.FC<RemappingFiltersProps> = ({
  onSelectionChange,
}) => {
  const { t } = useTranslation();

  const {
    series,
    fetchSeries,
    generations,
    fetchGenerations,
    engines,
    fetchEngines,
    ecus,
    fetchEcus,
    clearEngines,
    clearEcus,
    clearChanges,
    clearGenerations,
    fetchChanges
  } = useRemappingStore();

  const [selectedSeries, setSelectedSeries] = useState("");
  const [selectedGenerations, setSelectedGenerations] = useState("");
  const [selectedEngines, setSelectedEngines] = useState("");
  const [selectedEcus, setSelectedEcus] = useState("");

  useEffect(() => {
    fetchSeries();
  }, []);

  // Синхронизируем выбор с родителем
  useEffect(() => {
    onSelectionChange({
      series: selectedSeries,
      generation: selectedGenerations,
      engine: selectedEngines,
      ecu: selectedEcus,
    });
  }, [selectedSeries, selectedGenerations, selectedEngines, selectedEcus]);

  return (
    <div className="rounded-xl bg-content3 grid md:grid-flow-col max-md:grid-flow-row justify-stretch">
      {/* Series */}
      <div className="md:py-10 md:pl-10 md:pr-5 max-md:p-5 min-w-full">
        <p className="text-sm pb-3">{t("Series")}</p>
        <div className="flex align-middle rounded-lg bg-content2 h-12 px-3">
          <RemappingDropdown
            items={series}
            onSelect={(item) => {
              setSelectedGenerations("");
              setSelectedEngines("");
              setSelectedEcus("");
              clearEngines();
              clearEcus();
              clearChanges();
              setSelectedSeries(item);
              if (item) fetchGenerations(item);
            }}
            caption={selectedSeries}
          />
        </div>
      </div>

      {/* Generation */}
      <div className="md:py-10 md:px-5 max-md:p-5 min-w-full">
        <p className="text-sm pb-3">{t("Generation")}</p>
        <div className="flex align-middle rounded-lg bg-content2 h-12 px-3">
          <RemappingDropdown
            items={generations}
            onSelect={(item) => {
              setSelectedEngines("");
              setSelectedEcus("");
              clearEcus();
              clearChanges();
              setSelectedGenerations(item);
              if (item && selectedSeries)
                fetchEngines(selectedSeries, item);
            }}
            caption={selectedGenerations}
          />
        </div>
      </div>

      {/* Model (Engine) */}
      <div className="md:py-10 md:px-5 max-md:p-5 min-w-full">
        <p className="text-sm pb-3">{t("Model")}</p>
        <div className="flex align-middle rounded-lg bg-content2 h-12 px-3">
          <RemappingDropdown
            items={engines}
            onSelect={(item) => {
              setSelectedEcus("");
              clearChanges();
              setSelectedEngines(item);
              if (item && selectedSeries && selectedGenerations)
                fetchEcus(selectedSeries, selectedGenerations, item);
            }}
            caption={selectedEngines}
          />
        </div>
      </div>

      {/* Type (ECU) */}
      <div className="md:py-10 md:pl-5 md:pr-10 max-md:p-5 min-w-full">
        <p className="text-sm pb-3">{t("Type")}</p>
        <div className="flex align-middle rounded-lg bg-content2 h-12 px-3">
          <RemappingDropdown
            items={ecus}
            onSelect={(item) => {
              setSelectedEcus(item);
              if (item) fetchChanges(item);
            }}
            caption={selectedEcus}
          />
        </div>
      </div>
    </div>
  );
};

export default RemappingFilters;